import { createFileRoute } from '@tanstack/react-router'
import OpusUserAccess from 'User/components/Sections/OpusUserAccess'

export const Route = createFileRoute('/user/$userId/access')({
    component: OpusUserAccess,
})
